
export const talents = [
  {
    id: 1,
    name: '张伟',
    position: '高级前端工程师',
    experience: '5年',
    education: '本科',
    school: '北京理工大学',
    major: '计算机科学与技术',
    phone: '13812345678',
    email: 'zhangwei@email.com',
    status: '在职-考虑机会',
    skills: ['React', 'Vue', 'TypeScript', 'Node.js'],
    expectedSalary: '25K-35K',
    location: '北京',
    lastUpdated: '2024-01-15'
  },
  {
    id: 2,
    name: '李娜',
    position: 'UI/UX设计师',
    experience: '3年',
    education: '硕士',
    school: '清华大学',
    major: '视觉传达设计',
    phone: '13923456789',
    email: 'lina@email.com',
    status: '离职-立即到岗',
    skills: ['Figma', 'Sketch', 'Adobe Creative Suite', 'Principle'],
    expectedSalary: '18K-25K',
    location: '上海',
    lastUpdated: '2024-01-14'
  },
  {
    id: 3,
    name: '王强',
    position: 'Java后端开发工程师',
    experience: '7年',
    education: '本科',
    school: '华中科技大学',
    major: '软件工程',
    phone: '13734567890',
    email: 'wangqiang@email.com',
    status: '在职-考虑机会',
    skills: ['Java', 'Spring Boot', 'MySQL', 'Redis', 'Kafka'],
    expectedSalary: '30K-45K',
    location: '深圳',
    lastUpdated: '2024-01-13'
  },
  {
    id: 4,
    name: '陈静',
    position: '产品经理',
    experience: '4年',
    education: '硕士',
    school: '复旦大学',
    major: '工商管理',
    phone: '13645678901',
    email: 'chenjing@email.com',
    status: '离职-考虑机会',
    skills: ['产品设计', '用户研究', 'Axure', 'SQL', 'Python'],
    expectedSalary: '22K-30K',
    location: '上海',
    lastUpdated: '2024-01-12'
  }
];
